import LiveClassDao from '../dao/live-class.dao';
import type { Environment } from '../interfaces/environment';

export abstract class LiveClassService {
  static async getLiveClasses(env: Environment, teacherId?: number) {
    if (!teacherId) {
      throw new Error('Missing teacherId');
    }

    return LiveClassDao.getLiveClasses(env, teacherId);
  }
}
